import { Modal } from "react-bootstrap";
import ReactLoading from "react-loading";

export default function ApproveModal(props) {
    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span 
                        className={
                            props.type === "disapprove"
                                ? "color-red"
                                : "modal-header-color"
                        }> PLEASE CONFIRM </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <span >Are you sure you want to {props.text}?</span>
                    <div className="d-flex justify-content-end pt-5 pb-3">
                        <button type="button" className={props.type === "disapprove" ? "button-warning me-2" : "button-secondary me-2"} onClick={props.hide}>Cancel</button>
                        {props.isClicked === true && (
                            <div className={props.type === "disapprove" ? "button-warning-fill d-flex justify-content-center" : "button-tertiary d-flex justify-content-center"}>
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={30}
                                    width={30}
                                />
                            </div>
                        )}
                        {props.isClicked === false && (
                            <button type="button" className={props.type === "disapprove" ? "button-warning-fill" : "button-tertiary"} onClick={props.handler}>Proceed</button>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}